import { Navigate } from 'react-router-dom';
import { getOnboardingGuest } from '@/helpers/onboardingGuest';
import { successNavigationOptions } from '@/Pages/Success/types/successLocationState';

type AlreadyOnboardedGuardProps = {
  children: React.ReactNode;
};

/**
 * Convidado que JÁ tem biometria cadastrada nunca entra nas telas de
 * selfie/cadastro: cada passagem custa uma sessão de liveness + uma indexação
 * de face na AWS e não muda nada no cadastro dele. O `/identify` e o `/invite`
 * já roteiam certo — este guard cobre o resto (voltar no histórico, recarregar
 * a página, abrir o QR do desktop numa URL antiga).
 *
 * Sobra acompanhante declarado → `/invite` (a tela do grupo abre no cadastro
 * deles, que é o que falta fazer); senão `/success`, que mostra o comprovante
 * com os dados do convidado.
 */
export function AlreadyOnboardedGuard({ children }: AlreadyOnboardedGuardProps) {
  const guest = getOnboardingGuest();

  if (guest?.alreadyOnboarded === true) {
    if (guest.role !== 'companion' && guest.companions.pending > 0) {
      return <Navigate to="/invite" replace />;
    }
    return <Navigate to="/success" {...successNavigationOptions} />;
  }

  return children;
}
